(() => {
  if (window.__imVariantFocusInstalled) return;
  window.__imVariantFocusInstalled = true;

  let pending = null;
  const selector = 'input[type="radio"][data-variant-option-value]';

  const stop = () => {
    if (!pending) return;
    pending.observer.disconnect();
    window.clearTimeout(pending.timeout);
    window.clearTimeout(pending.cleanupTask);
    pending = null;
  };

  document.addEventListener('change', (event) => {
    stop();
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || !radio.matches(selector)) return;
    const picker = radio.closest('options-selection');
    if (!picker || document.activeElement !== radio || !radio.checked || radio.disabled) return;
    const variants = typeof picker.getVariantSelection === 'function' && picker.getVariantSelection();
    if (!variants || typeof variants.getProduct !== 'function') return;

    const state = { radio, picker, observer: null, timeout: null, cleanupTask: null };
    state.observer = new MutationObserver((records) => {
      if (pending !== state) return;
      if (!picker.isConnected || !radio.isConnected || radio.closest('options-selection') !== picker) {
        stop();
        return;
      }
      const moved = records.some((record) => Array.from(record.removedNodes).some((node) => node === radio || node.contains(radio)));
      if (!moved) return;
      const active = document.activeElement;
      const styles = window.getComputedStyle(radio);
      const restore = active === document.body && radio.checked && !radio.disabled
        && !radio.closest('[hidden], [inert], dialog:not([open])')
        && styles.display !== 'none' && styles.visibility !== 'hidden';
      if (restore) radio.focus({ preventScroll: true });
      else if (active !== radio) stop();
    });
    pending = state;
    state.observer.observe(picker, { childList: true, subtree: true });
    state.timeout = window.setTimeout(stop, 10000);
    Promise.resolve(variants.getProduct()).then(() => {
      if (pending === state) state.cleanupTask = window.setTimeout(() => {
        if (pending === state) stop();
      }, 0);
    }, () => {
      if (pending === state) stop();
    });
  }, true);

  document.addEventListener('focusin', (event) => {
    if (pending && event.target !== pending.radio) stop();
  }, true);
  document.addEventListener('pointerdown', stop, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' || event.key === 'Escape') stop();
  }, true);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
  });
  window.addEventListener('blur', stop);
  window.addEventListener('pagehide', stop);
})();
